<template>
  <settings-modal
    :locked="isLoading"
    class="t-subscription-edit-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Edit subscription plan</span>

    <v-layout row>
      <v-flex xs4>
        <v-text-field
          slot="activator"
          v-model="form.price"
          type="number"
          label="Price"
          class="t-price-input"
          :suffix="'EUR' | currencySign"
          :disabled="isLoading"
          :error-messages="getValidationErrorMessage('price')"
        />
      </v-flex>
    </v-layout>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-save-button"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || isLoading"
        @click="onSaveButtonClick"
      >Save</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import SettingsModal from '@/components/modals/SettingsModal.vue'
  import modal from '@/mixins/modal'
  import { mapActions, mapGetters } from 'vuex'
  import form from '@/mixins/form'
  import ErrorAlert from '@/components/ui/ErrorAlert.vue'
  import flashMessages from '@/mixins/flashMessages'
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import SubscriptionApi from '@/services/Api/Subscription'

  export default {
    name: 'SubscriptionEditModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [form, modal, flashMessages],
    data () {
      return {
        saveSubscriptionPriceApiRequest: new ApiRequest(
          SubscriptionApi.saveSubscriptionPrice
        ),
        error: null,
        isLoading: false,
        requiredFields: ['price'],
        form: {
          price: null
        }
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      subscriptionFormData () {
        return this.modal.data.formData
      }
    },
    created () {
      this.setFormData({
        price: this.subscriptionFormData.price ?? null
      })
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.setIsLoading(true)

        this.saveSubscriptionPriceApiRequest.execute(this.parsedFormInput)
          .then(() => this.showSuccessFlashMessage('Subscription has been successfully updated.', {
            onComplete: this.modal.data.successCallback
          }))
          .catch((error) => {
            this.setError(error)
            this.setIsLoading(false)
          })
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
